<template>
  <div>
    <div class="page_wrapper">
     {{$t('tokenExpired')}}
      <p v-if="page === 'confirmregister'">{{ $t('supportTeamMessage') }}</p>
      <p v-if="page === 'resetpassword'">
        {{$t('resendLabel')}}
        <router-link to="/forgot">
          <u style="color:#333333">{{$t('hereLabel')}}</u>
        </router-link>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['page'],
  data() {
    return {};
  },
};
</script>
<style scoped>
.banner-container,
.security_logos {
  display: none;
}
.page_wrapper {
  margin-top: 25vh;
  font-size: 22px;
  line-height: 25px;
  color: #333333;
}
.page_wrapper > div > a {
  color: #333333;
  text-decoration: underline;
}
</style>
